import styled from 'styled-components';

import { color } from '@creditornot/cb-ingredients/design-tokens';
import { Stack } from 'common/components/cookbook/Stack';
import { Typography as T } from 'common/components/cookbook/Typography/Typography';
import { media } from 'common/media';

const ContentStack = styled(Stack)`
  position: relative;
  margin-left: 8px;
  margin-right: 8px;
  height: calc(100% - 248px);
  @media ${media.sm} {
    margin-left: 24px;
    margin-right: 24px;
  }
  @media ${media.lg} {
    min-height: 500px;
  }
  user-select: none;
`;

const Image = styled.img`
  max-width: 50%;
  max-height: 100%;
  object-fit: contain;
  pointer-events: none;
  user-select: none;
`;

const DescriptionSection = styled.div`
  margin-top: 32px;
  color: ${color.textInverse};
  text-align: center;
  padding-left: 50px;
  padding-right: 50px;
  white-space: pre-wrap;
  user-select: none;
`;

const Space = styled.div`
  height: 170px;
  user-select: none;
`;

type Props = {
  description: string;
  imageUrl: string;
  isOnFirstStep: boolean;
  isOnLastStep: boolean;
  handleTouchStart: () => void;
  handlePreviousTouchEnd: () => void;
  onPreviousStep: () => void;
  handleNextTouchEnd: () => void;
  onNextStep: () => void;
};

export const ImageSmallSlide = ({ description, imageUrl }: Props) => (
  <>
    <ContentStack justifyContent="center" alignItems="center">
      <Image src={imageUrl} />
      <DescriptionSection>
        <T.bodyLabel>{description}</T.bodyLabel>
      </DescriptionSection>
    </ContentStack>
    <Space />
  </>
);
